import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import Logo from "../media/logo.svg";
import LoginForm from "../components/trackweb/LoginForm/LoginForm";
import useTrackWebContext from "../hooks/useTrackWebContext";

const LoginUser = () => {
  const { isLogin } = useTrackWebContext();
  const [resetPassword, setResetPassword] = useState(false);

  return (
    <>
      <div className="">
        <img
          src={Logo}
          className="w-52 m-auto mt-8 mb-12 md:mt-4 md:mb-24"
          alt="Club La Voz"
        />
      </div>
      <div className="text-center">
        <p className="font-body text-gray-900 font-bold text-2xl pt-4 pb-2">
          Te damos la bienvenida
        </p>
        <p className="font-body text-gray-900 font-normal text-lg pt-2 pb-4">
          Ingresá los datos de tu comercio
        </p>
      </div>
      <LoginForm
        resetPassword={resetPassword}
        setResetPassword={setResetPassword}
      />
      {/* {resetPassword === true && <div>mandale el mail ray</div>} */}
      {isLogin && <Navigate to="/" replace={true} />}
    </>
  );
};

export default LoginUser;
